import * as React from "react"
import type { SVGProps } from "react"

export const Playback100Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M6.25 8.75H5a.73.73 0 0 1-.534-.216A.73.73 0 0 1 4.25 8q0-.32.216-.535A.73.73 0 0 1 5 7.25h2q.319 0 .534.216A.73.73 0 0 1 7.75 8v8q0 .318-.216.534A.73.73 0 0 1 7 16.75a.73.73 0 0 1-.535-.216A.73.73 0 0 1 6.25 16zm8.4 4.42-1.927 3.22a.69.69 0 0 1-.621.36.7.7 0 0 1-.648-.375.7.7 0 0 1 .007-.75L13.79 11.7l-2.002-3.3a.71.71 0 0 1-.014-.767.71.71 0 0 1 .66-.383.75.75 0 0 1 .656.375l1.58 2.606 1.593-2.621a.67.67 0 0 1 .262-.265.75.75 0 0 1 .375-.095.7.7 0 0 1 .647.375q.216.375-.008.75L15.563 11.7l2.317 3.9a.7.7 0 0 1 .008.767.73.73 0 0 1-.673.383.75.75 0 0 1-.382-.103.7.7 0 0 1-.27-.272z"
    ></path>
  </svg>
)
